import { computed, type ComputedRef } from 'vue'

function initialsFromName(name?: string | null): string {
  const t = name?.trim()
  if (!t) return '?'
  const parts = t.split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

/** Figma: circular nurse avatar on rail — initials when no photo URL (future). */
export function useNurseAvatarInitials(nurseName: ComputedRef<string | undefined>): ComputedRef<string> {
  return computed(() => initialsFromName(nurseName.value))
}
